import React from "react";
import Header from "../layouts/header";
import AddUserIndex from "../components/addUser";

export default function AddUser() {

    return (
        <div>
            <Header />
            <AddUserIndex />
        </div>
    )
};